export default __webpack_public_path__ + "static/media/news35.445bf707.jpg";